export function viewFourDrop(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter, payload) {
  //also used to check if target and location node type is different
  let isStreakBroken = undefined;

  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      if (payload.groupId === groupItem.groupId)
        return {
          ...groupItem,
          groupNodes: groupItem.groupNodes.map(updateGroupNode),
        };
      else
        return {
          ...groupItem,
          groupNodes: groupItem.groupNodes.map(resetGroupNodeTooltip),
        };
    });
  };

  const resetGroupNodeTooltip = (groupNode) => {
    return {
      ...groupNode,
      nodeComponents: groupNode.nodeComponents.map((nodeComponent) => {
        return {...nodeComponent, showTooltip: false};
      }),
    };
  };

  const updateGroupNode = (groupNode) => {
    if (groupNode.nodeId === payload.nodeId) {
      return {
        ...groupNode,
        nodeComponents: updateNodeComponent(groupNode.nodeComponents),
      };
    } else return resetGroupNodeTooltip(groupNode);
  };

  // Checking node component type equality is needed
  const updateNodeComponent = (nodeComponents) => {
    // node has correct answer and node is empty of incorrect
    const correctNodeComponent = nodeComponents.find(
      (nodeComponent) =>
        nodeComponent.componentType === payload.componentType &&
        nodeComponent.answerId.includes(payload.optionId) &&
        !nodeComponent.answerId.includes(nodeComponent.droppedId)
    );
    const droppedNodeComponent = nodeComponents.find(
      (nodeComponent) =>
        nodeComponent.componentType === payload.componentType &&
        nodeComponent.id === payload.positionId
    );

    const swapCorrectAndDroppedNodeContents = () => {
      return nodeComponents.map((nodeComponent) => {
        if (nodeComponent.id === droppedNodeComponent.id) {
          return {
            ...correctNodeComponent,
            id: droppedNodeComponent.id,
            droppedId: payload.optionId,
            showTooltip: false,
          };
        } else if (nodeComponent.id === correctNodeComponent.id) {
          return {
            ...droppedNodeComponent,
            id: correctNodeComponent.id,
            droppedId: correctNodeComponent.droppedId,
            showTooltip: false,
          };
        } else return {...nodeComponent, showTooltip: false};
      });
    };

    //if any sibling has correct answer changes nodeComponent order to make dropped position correct
    if (correctNodeComponent) {
      isStreakBroken = false;
      return swapCorrectAndDroppedNodeContents();
    }

    return nodeComponents.map((nodeComponent) => {
      if (
        nodeComponent.componentType === payload.componentType &&
        nodeComponent.id === payload.positionId
      ) {
        isStreakBroken = true;
        return {
          ...nodeComponent,
          droppedId: payload.optionId,
          showTooltip: true,
        };
      }
      return {...nodeComponent, showTooltip: false};
    });
  };

  const updateDroppedOptionVisibility = (optionItem) => {
    if (isStreakBroken === undefined) {
      return optionItem;
    } else
      return {
        ...optionItem,
        list: optionItem.list.map((listItem) => {
          if (listItem.id === payload.optionId)
            return {...listItem, visible: false};
          return listItem;
        }),
      };
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: designChapter.currentView.options.map(
        updateDroppedOptionVisibility
      ),
      ...updateCompleteFeedbackData(designChapter.currentView, isStreakBroken),
    },
    currentStreak: updateCurrentStreak(
      designChapter.currentStreak,
      isStreakBroken
    ),
    longestStreak: updateLongestStreak(designChapter, isStreakBroken),
  };
}

function updateCurrentStreak(currentStreak, isStreakBroken) {
  if (isStreakBroken != undefined) {
    if (isStreakBroken) return 0;
    else return currentStreak + 1;
  }
  return currentStreak;
}

function updateLongestStreak({longestStreak, currentStreak}, isStreakBroken) {
  if (
    isStreakBroken ||
    isStreakBroken === undefined ||
    longestStreak > currentStreak
  )
    return longestStreak;
  else return currentStreak + 1;
}

function updateCorrectCount(correctNodeComponents, isStreakBroken) {
  if (isStreakBroken || isStreakBroken === undefined)
    return correctNodeComponents;
  return correctNodeComponents + 1;
}

function updateCompleteFeedbackData({correctNodeComponents}, isStreakBroken) {
  if (correctNodeComponents != undefined) {
    if (isStreakBroken || isStreakBroken === undefined)
      return {correctNodeComponents};
    return {correctNodeComponents: correctNodeComponents + 1};
  }
  return {};
}
